import { defineComponent as _defineComponent } from 'vue'
import { IndividualGroup } from 'ah-api-gateways';
import GroupListing from '@/app/components/groups/GroupListing.vue';
import GroupInfo from '@/app/components/groups/GroupInfo.vue';
import { AnimatedListingWithSubViewState } from '@/app/components/common/animation/AnimatedListingWithSubView.vue';
import { groupTableFieldsFull, groupTableFieldsMinimal } from '@/app/components/groups/tableFields/groupTableFields';
import GroupEditModal from '@/app/components/groups/GroupEditModal.vue';
import InfoTooltip from '@/app/components/common/InfoTooltip.vue';
import { editRoute } from 'ah-common-lib/src/helpers/route';
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import { useMediaQuery } from 'ah-common-lib/src/mediaQuery';


export default /*#__PURE__*/_defineComponent({
  __name: 'GroupsSettingsView',
  props: {
  groupId: {
    type: String,
    required: false,
  },
},
  setup(__props) {

const props = __props;



const mediaQuery = useMediaQuery();

const groupListing = ref<GroupListing>();

const route = useRoute();

const router = useRouter();

const animatedState = ref<AnimatedListingWithSubViewState>();

const groupTableConfig = computed(() =>
  mediaQuery.is('mdDown') && !animatedState.value?.wideList
    ? { tableFields: groupTableFieldsMinimal }
    : { tableFields: groupTableFieldsFull }
);

function goToGroup(group?: IndividualGroup, replace = false) {
  const groupRoute = editRoute(route, {
    params: {
      groupId: !group || props.groupId === group.id ? '' : group.id,
    },
  });
  router[replace ? 'replace' : 'push'](groupRoute);
}

function onGroupDeleted() {
  goToGroup(undefined, true);
  refreshGroups();
}

function refreshGroups() {
  if (groupListing.value) {
    groupListing.value.loadData();
  }
}

return { __sfc: true,props, mediaQuery, groupListing, route, router, animatedState, groupTableConfig, goToGroup, onGroupDeleted, refreshGroups, GroupListing, GroupInfo, GroupEditModal, InfoTooltip }
}

})